export function escapeRegExp(s: string) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function buildHighlighter(rawQuery = '') {
    const bits = rawQuery
        .toLowerCase()
        .replace(/[-_/\\.,]+/g, ' ')
        .trim()
        .split(/\s+/)
        .filter(Boolean);

    const glued = bits.join('');
    if (glued && !bits.includes(glued)) bits.push(glued);

    const tokens = Array.from(new Set(bits)).sort((a, b) => b.length - a.length);
    if (!tokens.length) return (txt: string) => txt;

    const regex = new RegExp(`(${tokens.map(escapeRegExp).join('|')})`, 'gi');
    return (txt: string | null | undefined) =>
        (txt ?? '').replace(regex, '<mark>$1</mark>');
}